// @flow

import * as React from 'react';
import Config from '@insolus/config';
import { Link } from '@insolus/ui-kit';
import { ReactComponent as LogoComponent } from './img/logo.svg';

export type Props = {|
    url?: string
|};

const Logo = ({ url }: Props): React.Node => {
    const Component = <LogoComponent title={Config.get('app.name')} />;
    return (
        <div className="Logo">
            {url
                ? <Link to={url}>{Component}</Link>
                : Component}
        </div>
    );
};

export default Logo;
